let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let TabSet = require("../widgets/TabSet");
let esUtils = require("ES/utils/esUtils");
let Connect = require("./connect");
let AuthedUserSession = require("../../utils/AuthedUserSession");
let AdvancedSettings = require("./advanced");
let Preferences = require("./preferences");
let ActionLists = require("./action_lists");
let AccountingLock = (AuthedUserSession.is_st_family) ? require("./AccountingLock") : null;
let ClientPortal = require("./ClientPortal");
let StandardLayout = require("../layout/StandardLayout");
let Constants = require("../../utils/Constants");

if ((_.size(AuthedUserSession.doIHaveAccess.admin.getSIDs()) === 0) && (AuthedUserSession.st_usertype !== Constants.ST_USERTYPE_SUPER_ADMIN)) {
    AccountingLock = null;//only show this tab if they have admin
}

if (!_.isEmpty(AuthedUserSession.doIHaveAccess.limited_speaker.getSIDs()) || _.isEmpty(AuthedUserSession.doIHaveAccess.admin.getSIDs())) {
    ActionLists = null;
}

//NOTE
//NOTE these keys on this are use in urls so don't casually RENAME them
//NOTE
let tabs = {
    preferences: {
        name: "Preferences",
        render: Preferences
    },
    action_list: {
        name: "Action Lists",
        render: ActionLists
    },
    connect: {
        name: "Connect",
        render: Connect
    },
    accounting_lock: {
        name: "Accounting Lock",
        render: AccountingLock
    },
    client_portal: {
        name: "Client Portal",
        render: ClientPortal
    },
    advanced: {
        name: "Advanced",
        render: AdvancedSettings
    }
};

if (AuthedUserSession.is_st) {
    delete tabs.action_list;
    delete tabs.client_portal;
}


_.each(tabs, function (tab, id) {
    if (!tab.render) {
        delete tabs[id];
    }
});

module.exports = dd.createClass({
    render(){
        let {url_args, Displaylists} = this.props;//url format: #/account_settings/:tab/:redir/:sid

        let url_tab = null;
        let url_redir = null;
        let url_sid = -1;

        if (url_args[0] === "account_settings" && _.has(tabs, url_args[1])) {
            url_tab = url_args[1];

            url_redir = _.isString(url_args[2]) ? esUtils.decode_redir(url_args[2]) || null : null;

            url_sid = _.parseInt(url_args[3]);
            url_sid = _.isNaN(url_sid) || url_sid < 1 ? -1 : url_sid;
        }

        let back_url = _.first(_.reject(this.props.hash_history, function (hash) {
                return /^\/account_settings/.test(hash);
            })) || "/";

        return StandardLayout({Displaylists},
            dd.div({className: "container AccountSettings"},
                dd.div({className: "pull-right", style: {marginTop: 22}},
                    dd.a({href: "#" + back_url, className: "btn btn-default"},
                        dd.i({className: "fa fa-arrow-left"}),
                        " Back to events"
                    )
                ),
                dd.h1(null, "Account Settings"),
                TabSet({
                    tabs: _.mapValues(tabs, function (tab, id) {
                        tab.url = "#/account_settings/" + id;
                        if (url_redir) {
                            tab.url += "/" + url_args[2];//append the un-encoded one
                            if (url_sid > 0) {
                                tab.url += "/" + url_sid;
                            }
                        }
                        return tab;
                    }),
                    render_props: {
                        redir: url_redir,
                        sid: url_sid,
                        url_args,
                        Displaylists
                    },
                    selected_tab: url_tab
                })
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/index.js